import { Outlet } from "react-router-dom";
//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { HomeIcon } from "lucide-react";

export const navigation: any = [
  {
    name: "Dashboard",
    href: "",
    icon: "",
    children: [
      {
        name: "Home",
        href: "/file-manager",
        icon: HomeIcon,
        activeIcon: HomeIcon,
      },
    ],
  },
];

const DashboardLayout = () => {
  return (
    <DashboardLayoutService>
      <div className={tw` p-2 h-full`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
